var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.terms),function(term){return _c('Term',{key:term.term,attrs:{"facet":_vm.facet,"term":term}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }